<!-- Personel Ana Sayfa: Uygulama Kartları Grid -->
<div class="personel-ana-sayfa">
  <div class="uygulama-grid">
    @for (kart of kartlar; track kart.route) {
      @if (kartGorunurMu(kart)) {
        <a class="uygulama-kart" [class.fiko-kilit]="!lisansli(kart)"
           [routerLink]="lisansli(kart) ? [kart.route] : null" [style.--kart-renk]="kart.renk">
          <div class="uygulama-kart-ust" [style.background]="kart.gradient">
            <span class="uygulama-kart-simge">{{ kart.ikon }}</span>
          </div>
          <div class="uygulama-kart-alt">
            <div class="uygulama-kart-baslik">{{ kart.baslik }}</div>
            <div class="uygulama-kart-aciklama">{{ kart.aciklama }}</div>
          </div>
        </a>
      }
    }
  </div>
</div>
